// Main entry point for MouldFlow Surveys PWA TypeScript
// This file is bundled by esbuild into wwwroot/js/app.js

import { indexedDbStorage, photoHelpers, photoStorage } from './indexeddb-storage';
import { photoStorageInterop } from './photo-storage-interop';
import { checkOnlineStatus, addOnlineStatusListener } from './connectivity';
import { registerServiceWorker } from './service-worker-registration';
import { initializeIosSupport } from './ios-support';
import { 
    getInstallState, 
    setupInstallPrompt, 
    triggerInstallPrompt, 
    shouldShowInstallPrompt 
} from './pwa-install';
import { authStorage } from './auth-storage';
import './telemetry'; // Registers window.telemetry

// Declare global window extensions for Blazor interop
declare global {
    interface Window {
        indexedDbStorage: typeof indexedDbStorage;
        checkOnlineStatus: typeof checkOnlineStatus;
        addOnlineStatusListener: typeof addOnlineStatusListener;
        pwaInstall: {
            getInstallState: typeof getInstallState;
            triggerInstallPrompt: typeof triggerInstallPrompt;
            shouldShowInstallPrompt: typeof shouldShowInstallPrompt;
        };
        photoHelpers: typeof photoHelpers;
        photoStorage: typeof photoStorage;
        photoStorageInterop: typeof photoStorageInterop;
        authStorage: typeof authStorage;
    }
}

// Expose APIs to window for Blazor interop
window.indexedDbStorage = indexedDbStorage;
window.checkOnlineStatus = checkOnlineStatus;
window.addOnlineStatusListener = addOnlineStatusListener;
window.pwaInstall = {
    getInstallState,
    triggerInstallPrompt,
    shouldShowInstallPrompt
};
window.photoHelpers = photoHelpers;
window.photoStorage = photoStorage;
window.photoStorageInterop = photoStorageInterop;
window.authStorage = authStorage;

// Initialize PWA features
registerServiceWorker();
initializeIosSupport();
setupInstallPrompt();

console.log('[MouldFlow] PWA scripts initialized');
